// extracted by mini-css-extract-plugin
export default {"tag":"RoleTag-index__tag--f6tQ3"};